import React, { useState } from "react";
import Status from "../Components/Status";
import env, { normalPriceCount, rxFindCount } from "../../env";
import ErrorAction from "../../components/Modal/ErrorAction";
import PostReq from "../../utils/PostReq";

function MessagesTableRow(props) {
  const [openOption, setOpenOption] = useState(0);
  const [checkState, setCheckState] = useState(false);
  const [DeletePop, setDeletePop] = useState(false);

  const activeAcc = props.index === props.detail;
  const item = props.item;
  const ReadRow = async () => {
    const result = await PostReq({
      method: "Post",
      url: "/panel/contact/read-contact",
      body: { contactId: item._id },
    });
    if (result.success) window.location.reload();
  };
  return (
    <React.Fragment>
      <tr className={activeAcc ? "activeAccordion" : "accordion"}>
        <td>{item?.cName}</td>
        <td>{item?.phone}</td>
        <td style={{ minWidth: "300px", textAlign: "right" }}>
          {item?.message}
        </td>
        <td>
          <div className="or-date">
            <p className="date">
              {new Date(item.date).toLocaleDateString("fa")}
            </p>
            <p className="time">
              {new Date(item.date).toLocaleTimeString(
                props.lang === "persian" ? "fa" : "en",
              )}
            </p>
          </div>
        </td>
        <td>{item?.active ? "حوانده نشده" : "خوانده شده"}</td>

        <td>
          <div className="more-btn">
            {/* <i
              className="tableIcon fas fa-edit"
              onClick={() => (window.location.href = "/faq/detail/" + item._id)}
            ></i> */}
            {item?.active ? (
              <i
                class="fa fa-check-square"
                style={{ color: "green", fontSize: "1.5rem" }}
                onClick={() => setDeletePop(item._id)}
              ></i>
            ) : (
              <></>
            )}
          </div>
        </td>
      </tr>
      {DeletePop ? (
        <ErrorAction
          text={"آیا این پیام خوانده شود؟"}
          buttonText={"بله"}
          color={"red"}
          close={() => setDeletePop(false)}
          action={ReadRow}
        />
      ) : (
        <></>
      )}
    </React.Fragment>
  );
}
export default MessagesTableRow;
